import React from "react";
import { Label } from "@/components/ui/label";
import {
  Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from "@/components/ui/tooltip";
import { Info } from "lucide-react";

export default function FieldHint({ label, hint, required = false, htmlFor, className = "" }) {
  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <Label htmlFor={htmlFor} className="overline">
        {label}{required && <span className="text-primary ml-0.5">*</span>}
      </Label>
      {hint && (
        <TooltipProvider delayDuration={150}>
          <Tooltip>
            <TooltipTrigger asChild>
              <button type="button" className="text-muted-foreground hover:text-foreground" tabIndex={-1}>
                <Info className="w-3.5 h-3.5" />
              </button>
            </TooltipTrigger>
            <TooltipContent side="top" className="max-w-xs text-xs">
              {hint}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
}
